import { httpClient } from "./httpClient";

const getEmployeeTypeByidCompany = (query) => {
  return httpClient.get(`/employee-type`, { params: query });
};

const addEmployeeType = (data) => {
  return httpClient.post(`/employee-type`, data);
};

const updateEmployeeType = (data) => {
  return httpClient.put(`/employee-type`, data);
};

const deleteEmployeeType = (idEmployeeType) => {
  return httpClient.delete(`/employee-type/${idEmployeeType}`);
};

export default {
  getEmployeeTypeByidCompany,
  addEmployeeType,
  updateEmployeeType,
  deleteEmployeeType,
};
